import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="support--pdf-preview"
//
// Shared, surface-agnostic modal that hosts the project `pdf-viewer`
// (stimulus-pdf-viewer) on demand. The viewer markup lives in a <template>
// and is only cloned/inserted when a PDF is opened, so none of the page's
// PDFs load until the user actually requests a preview. Closing removes the
// clone, disconnecting the pdf-viewer controller and freeing its resources.
export default class extends Controller {
  static targets = ["overlay", "template", "container"]

  open({ params: { documentUrl, documentName, downloadUrl } }) {
    if (!this.hasTemplateTarget || !this.hasContainerTarget) return

    const fragment = this.templateTarget.content.cloneNode(true)

    const viewer = fragment.querySelector("[data-controller~='pdf-viewer']")
    if (viewer) {
      if (documentUrl)
        viewer.setAttribute("data-pdf-viewer-document-url-value", documentUrl)
      if (documentName)
        viewer.setAttribute("data-pdf-viewer-document-name-value", documentName)
    }

    const downloadLink = fragment.querySelector(
      "[data-support--pdf-preview-target='downloadLink']",
    )
    if (downloadLink) {
      downloadLink.setAttribute("href", downloadUrl || documentUrl || "#")
      if (documentName) downloadLink.setAttribute("download", documentName)
    }

    this.containerTarget.innerHTML = ""
    this.containerTarget.appendChild(fragment)

    this.overlayTarget.classList.remove("hidden")
    this.overlayTarget.classList.add("flex")
    document.body.style.overflow = "hidden"
  }

  close() {
    if (!this.hasOverlayTarget) return
    this.overlayTarget.classList.add("hidden")
    this.overlayTarget.classList.remove("flex")
    if (this.hasContainerTarget) this.containerTarget.innerHTML = ""
    document.body.style.overflow = ""
  }

  closeBackground(event) {
    if (event.target === this.overlayTarget) {
      this.close()
    }
  }

  stopPropagation(event) {
    event.stopPropagation()
  }

  disconnect() {
    document.body.style.overflow = ""
  }
}
